import { Row } from 'antd'
import { MemberProps } from 'app/components/Core/convention'
import KForm from 'app/components/Modules/Form/KForm'
import KInputText from 'app/components/Modules/Form/KInputText'
import KCol from 'app/components/UI-Elements/Layout/KCol'
import { KFormProps, RecordType } from 'app/constants/GlobalTypes'
import * as React from 'react'
interface Props extends KFormProps<IVoucher> {
  submitTitle?: string
  hideSubmit?: boolean
}

const Form: React.FC<MemberProps<Partial<IVoucher>, Props>> = ({
  member,
  props: { onSuccess, hideSubmit = false, submitTitle } = {}
}) => {
  return (
    <KForm
      submitButtonProps={{ type: 'secondary', ghost: member?.id ? true : false }}
      initialFetch={false}
      recordId={member.id}
      silentSuccess={true}
      hideSubmit={hideSubmit}
      onSuccess={onSuccess}
      initialValues={member}
      portalId={'submit-voucher'}
      submitTitle={submitTitle}
      recordType={RecordType.voucher}
      layout="vertical">
      <Row align="bottom" gutter={[8, 24]} wrap={false}>
        <KCol flex="auto">
          <KInputText
            disabled={Boolean(member.rental.voucher_id)}
            hasPlaceholder
            className="full-width"
            hasFeedback={false}
            style={{ height: '40px' }}
            name="code"
          />
          <KInputText hidden name="rental_id" />
        </KCol>
        <KCol flex="none">
          <div className="mb-2" id="submit-voucher"></div>
        </KCol>
      </Row>
    </KForm>
  )
}

export default Form
